import useMutation from '../hooks/useMutation';
import { ContactMessageRequest } from '../model/contact';

const ep = '/contact/messages';

export function useCreateContactMessageMutation() {
  return useMutation<ContactMessageRequest, void>(ep, 'post');
}